import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import type { Job } from "~/db/types";
import { FacebookIcon, LinkIcon, Share2, TwitterIcon } from "lucide-react";
import WhatsAppIcon from "./icons/whatsAppIcon";
import { Link } from "@remix-run/react";
import {
  buildShareURLFaceBook,
  buildShareURLTelegram,
  buildShareURLTwitter,
  buildShareURLWhatsApp,
} from "~/utils/buildShareURL";
import { useEffect, useState } from "react";
import TelegramIcon from "./icons/telegramIcon";

export default function ShareDropDown({ job }: { job: Job }) {
  const [urls, setUrls] = useState({
    facebook: "",
    twitter: "",
    whatsapp: "",
    telegram: "",
  });

  useEffect(() => {
    const URL = { facebook: "", twitter: "", whatsapp: "", telegram: "" };
    URL["facebook"] = buildShareURLFaceBook(job);
    URL["twitter"] = buildShareURLTwitter(job);
    URL["whatsapp"] = buildShareURLWhatsApp(job);
    URL["telegram"] = buildShareURLTelegram(job);

    setUrls(URL);
  }, [job]);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <p className="flex items-center">
          <Share2 className="mr-2" size={16} /> Share
        </p>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuItem
          key={"WhatsApp"}
          onClick={(ev) => ev.stopPropagation()}
        >
          <Link to={urls["whatsapp"]}>
            <div className="flex items-center">
              <WhatsAppIcon />
              <span className="ml-3">WhatsApp</span>
            </div>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem
          key={"telegram"}
          onClick={(ev) => ev.stopPropagation()}
        >
          <Link to={urls["telegram"]}>
            <div className="flex items-center">
              <TelegramIcon />
              <span className="ml-3">Telegram</span>
            </div>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem
          key={"Facebook"}
          onClick={(ev) => ev.stopPropagation()}
        >
          <Link to={urls["facebook"]}>
            <div className="flex items-center">
              <FacebookIcon />
              <span className="ml-3">Facebook</span>
            </div>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem
          key={"Twitter"}
          onClick={(ev) => ev.stopPropagation()}
        >
          <Link to={urls["twitter"]}>
            <div className="flex items-center">
              <TwitterIcon />
              <span className="ml-3">Twitter</span>
            </div>
          </Link>
        </DropdownMenuItem>

        <DropdownMenuItem
          key={"CopyLink"}
          onClick={(ev) => {
            navigator.clipboard.writeText(
              `${window.location.origin}/job/${job.id}`
            );
            ev.stopPropagation();
          }}
        >
          <LinkIcon />
          <span className="ml-3">Copy Link</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
